var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 63,
    viewBox: "0 0 108 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0908 19.436L37.8216 37.0357V20.5036H40.5992V43.8029L23.8691 26.2018V42.8831H21.0908V19.436Z",
    fill: "#4E6E7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7306 24.7778C59.1351 23.351 56.9493 22.5806 54.8494 22.5806C49.8521 22.5806 46.0386 26.7659 46.0386 31.7225C46.0386 36.6184 49.8235 40.8044 54.7889 40.8044C56.9779 40.8044 59.0741 39.9735 60.7306 38.4896V41.7856C59.0151 42.7938 56.8292 43.3574 54.8775 43.3574C48.523 43.3574 43.2598 38.2836 43.2598 31.8115C43.2598 25.1923 48.5524 20.0288 55.115 20.0288C57.0667 20.0288 59.0445 20.5037 60.7306 21.5419V24.7778Z",
    fill: "#4E6E7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.301 37.9566C82.0139 36.414 82.901 33.8299 82.901 31.6934C82.901 26.7659 79.2345 22.6417 74.0062 22.6417C68.7704 22.6417 65.105 26.7659 65.105 31.6934C65.105 36.798 69.1871 40.7455 74.0062 40.7455C75.3629 40.7455 77.0784 40.3291 78.4384 39.471L73.3247 34.4529H76.784L80.301 37.9566ZM82.2799 43.3574L80.3611 41.3685C78.5283 42.6467 76.134 43.3574 74.0063 43.3574C67.562 43.3574 62.3273 38.341 62.3273 31.6934C62.3273 25.2818 67.6199 20.0288 74.0063 20.0288C80.3883 20.0288 85.6798 25.2818 85.6798 31.6934C85.6798 34.8695 84.3777 37.8636 82.1932 39.9451L85.651 43.3574H82.2799Z",
    fill: "#B52532"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6478 25.6686L92.6856 34.7205H100.61L96.6478 25.6686ZM91.5351 37.2708L88.993 42.8831H86.0048L96.6478 19.553L107.289 42.8831H104.303L101.761 37.2708H91.5351Z",
    fill: "#4E6E7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24032 42.6179C9.46874 46.6467 12.8987 48.871 16.5752 50.0969L17.3033 45.6973C14.6103 44.586 12.0574 42.9344 10.7789 40.185C7.96374 34.1236 11.3348 22.7374 33.0553 0.104736C10.7551 22.7886 6.07029 35.5031 8.24032 42.6179Z",
    fill: "#4E6E7D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3174 51.6604C12.4406 50.4122 8.65111 48.1017 7.26578 43.8321C4.90646 36.5702 9.4991 23.6495 32.4383 0.669189C5.62751 27.1434 1.37734 41.3437 4.7624 48.9602C6.73402 53.3938 11.2881 55.5881 15.4901 56.6764",
    fill: "#4E6E7D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40154 51.3889C0.137968 43.8413 3.4603 29.2626 32.0112 1.08276C-9.33246 41.5547 -2.41251 55.5881 7.80763 60.4507C10.0527 61.5194 12.4431 62.1359 14.5262 62.5027L15.1895 58.4925C11.2329 57.4889 6.70949 55.4709 4.40154 51.3889Z",
    fill: "#4E6E7D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.f08c067037da2fb06fe57bc40d2dbdc9.svg";
export { ForwardRef as ReactComponent };